import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MaintenanceWindowPreviewPatchManagementDataProviderFactory } from '../factory/MaintenanceWindowPreviewPatchManagementDataProviderFactory';
import { MaintenanceWindowPreviewPatchManagementBaseDataProvider } from '../dataProvider/MaintenanceWindowPreviewPatchManagementBaseDataProvider';
import { MaintenanceWindowPreviewPatchManagementWebComponentSchema } from '../types';

export class MaintenanceWindowPreviewPatchManagementRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MaintenanceWindowPreviewPatchManagementDataProviderFactory;
  public dataProvider: MaintenanceWindowPreviewPatchManagementBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MaintenanceWindowPreviewPatchManagementDataProviderFactory(),
    });
  }

  async getDataForView(
    maintenanceWindowId: string
  ): Promise<MaintenanceWindowPreviewPatchManagementWebComponentSchema> {
    return this.dataProvider.getDataForView(maintenanceWindowId);
  }
}
